import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Building2 } from 'lucide-react';
import { formatUsd } from '@/lib/receiptsData';
import { cn } from '@/lib/utils';

export const PerJobReceiptsCard = ({ rows = [], onPick }) => {
  const { t } = useTranslation();
  const top = rows.slice(0, 6);
  return (
    <Card
      className="border-[hsl(var(--hairline))] bg-[hsl(var(--card))]"
      data-testid="receipts-per-job"
    >
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Building2 size={14} className="text-[hsl(var(--primary))]" />
            <h2 className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
              {t('receiptScanner.byJob')}
            </h2>
          </div>
          <span className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
            {t('receiptScanner.jobsCount', { count: rows.length })}
          </span>
        </div>
        {top.length === 0 ? (
          <div className="text-sm text-muted-foreground py-6 text-center">
            {t('receiptScanner.noReceiptsByJob')}
          </div>
        ) : (
          <div className="space-y-2">
            {top.map((r) => (
              <button
                key={r.job_id}
                type="button"
                onClick={() => onPick?.(r.job_id)}
                data-testid={`receipts-per-job-${r.job_id}`}
                className={cn(
                  'w-full text-left rounded-md border border-border bg-[hsl(var(--muted))]/40 px-3 py-2 hover:border-[hsl(var(--primary))]/30 transition-colors'
                )}
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <div className="text-xs font-semibold text-foreground truncate">
                      {r.job_name}
                    </div>
                    <div className="text-[11px] text-muted-foreground truncate">
                      {r.client || t('receiptScanner.noClient')} {'\u00b7'}{' '}
                      {t('receiptScanner.receiptsCount', { count: r.count })}
                    </div>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="text-sm font-semibold text-foreground tabular-nums">
                      {formatUsd(r.total)}
                    </div>
                    <div className="text-[11px] text-[hsl(var(--success))]">
                      {formatUsd(r.rebate)} {t('receiptScanner.rebateSuffix')}
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PerJobReceiptsCard;
